import React from 'react'
import axios from 'axios'
import { useEffect, useState } from 'react'
import { Button } from "flowbite-react";
import { Table, TableBody, TableCell, TableHead, TableHeadCell, TableRow } from "flowbite-react";
import { PencilSquareIcon, ArrowUpTrayIcon, ListBulletIcon, TrashIcon } from '@heroicons/react/24/outline'
import Modals from '../../components/Modal'
import FormArea from './FormArea';

const Areas = () => {
    const [isModalOpen, setIsModalOpen] = useState(false);
    const closeModal = () => setIsModalOpen(false);
    const [modalTitle, setModalTitle] = useState("");
    const [areaId, setAreaId] = useState(null);
    const [areas, setAreas] = useState([]);
    const [error, setError] = useState(null);
    const [isCreating, setIsCreating] = useState(false);
    
    const openModal = (title,areaId,editMode) => {
        setModalTitle(title);
        setIsModalOpen(true);
        setAreaId(areaId);
        setIsCreating(editMode);
    };
    const handleFormSubmit = async(data) => {
        
        let name = data.name == "";
        if(name){ alert("Ingrese el area"); return;}

        let description = data.description == "";
        if(description){ alert("Ingrese la descripción"); return;}

        let status = data.status == "";
        if(status){ alert("Seleccione el estado"); return;}


        try {
            const response = await axios.post(
                `${((import.meta.env.VITE_ENV=='development')?import.meta.env.VITE_BACKEND_LOCAL:import.meta.env.VITE_BACKEND)}/area/create`,
                data,
                {
                    withCredentials: true,
                }
            );
            setAreas([...areas, response.data.new_area]);
        } catch (error) {
            
        }

        closeModal(); 
    };

    const handleFormUpdate = async(data) => {
        
        try {
            const response2 = await axios.put(
                `${((import.meta.env.VITE_ENV=='development')?import.meta.env.VITE_BACKEND_LOCAL:import.meta.env.VITE_BACKEND)}/area/${areaId}/update`,
                data,
                {
                    withCredentials: true,
                }
            );

            console.log("areaId",areaId);
            setAreas(
                areas.map((area) =>
                    area.id === areaId ? { ...areas, ...response2.data.area } : area
                )
            ); 
        } catch (error) {
            
        }

        closeModal(); 
    }

    const handleRemove = async (id) => {
        const confirma = confirm('confirma la eliminación del area?');
        if (!confirma) return;
        
        try{
            const response = await axios.delete(
                `${((import.meta.env.VITE_ENV=='development')?import.meta.env.VITE_BACKEND_LOCAL:import.meta.env.VITE_BACKEND)}/area/${id}/delete`,
                {
                    withCredentials: true,
                }
            );
            if (response.statusText !== "OK") {
                throw new Error(response.message || 'Error en la obtención de datos');
            }
            setAreas(areas.filter((area) => area.id !== id));
            setToastShow(true)

        }catch(error){
            
        }
    }

    useEffect(()=>{
        const getAreas = async () => {
            try {
                const response = await axios.get( 
                    `${((import.meta.env.VITE_ENV=='development')?import.meta.env.VITE_BACKEND_LOCAL:import.meta.env.VITE_BACKEND)}/areas`,
                    {
                        withCredentials: true,
                    }
                );

                if (response.statusText !== "OK") {
                    throw new Error(response.message || 'Error en la obtención de datos');
                }

                setAreas(response.data);
            } catch (error) {
                setError(error.message);
            }
        }
        
        getAreas();

    },[]);

    return (
        <>
            <div className="p-2 mt-4 flex justify-between">
                <h1 className="text-xl mb-2 px-3 flex-col">Areas para centro de recursos</h1>
                <div className="flex justify-end">
                    <Button className="text-gray-600" onClick={()=>openModal("Areas",null,true)} color='gray'>Crear</Button>
                </div>
                {error && <div className="text-red-500">{error}</div>}
            </div>
            <div className="overflow-x-auto text-left">
                <Table>
                    <TableHead>
                        <TableHeadCell className="text-left">Area</TableHeadCell>
                        <TableHeadCell className="text-left">Descripción</TableHeadCell>
                        <TableHeadCell className="text-left">Estado</TableHeadCell>
                        <TableHeadCell>
                            <span className="srOnly">Acción</span>
                        </TableHeadCell>
                    </TableHead>
                    <TableBody className="divide-y">
                        {areas.map((area) => (
                            <TableRow key={area.id} className="bg-white dark:border-gray-700 dark:bg-gray-800">
                                <TableCell className="whitespace-nowrap font-medium text-gray-900 dark:text-white">
                                    {area.name}
                                </TableCell>
                                <TableCell>{area.description}</TableCell>
                                <TableCell>{(parseInt(area.status)===1)?'Activo':'Inactivo'}</TableCell>
                                <TableCell className="inline-flex">
                                    <a href="#" onClick={()=>openModal("Areas",area.id, false)}>
                                        <PencilSquareIcon className="w-5 text-blue-500 mr-3" title="Editar Area"/>
                                    </a>
                                    <a href="#" onClick={()=>handleRemove(area.id)}>
                                        <TrashIcon className="w-5 text-blue-500 mr-3" title="Eliminar area"/>
                                    </a>
                                </TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </div>

            <Modals isOpen={isModalOpen} onClose={closeModal} title={modalTitle} modalSize={"md"}>
                <FormArea onSubmit={isCreating ? handleFormSubmit : handleFormUpdate} onClose={closeModal} areaId={areaId} />
            </Modals>
        </>
  )
}

export default Areas
